module.exports = __webpack_public_path__ + "static/media/report-green.ce8b589f.svg";